/**
 * Hand a Blob to the browser as a file download. The anchor has to be in the document for the
 * synthetic click to be honoured, so it is appended and removed around the click.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
}
